import IconPayOff from '@/assets/fonts/system-font/webfonts/icon-pay-off.svg'
import IconPayOffInN from '@/assets/fonts/system-font/webfonts/icon-pay-off-in-n.svg'
import IconPayDown from '@/assets/fonts/system-font/webfonts/icon-pay-down.svg'
import { DataType } from '@/util/index'
const ACTION = DataType.PaymentScheduleAction
const MULTI_PAYMENT_SCHEDULE_ACTION = {
  PAY_OFF: {
    title: ACTION.PAY_OFF.text,
    value: ACTION.PAY_OFF.value,
    iconPath: IconPayOff,
    privilegeCode: DataType.PrivilegeCode.PAY_OFF,
    fieldClass: 'lg4',
    limitValue: true,
    fields: [
      { label: 'Pay Off Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' },
      { label: 'Payment Mode', fieldKey: 'transactionMode', template: '{transactionMode}', disabled: true, controlType: 'select', items: { transactionMode: DataType.TransactionMode } },
      { label: 'Amount', fieldKey: 'amount', template: '{amount}', format: 'currency', disabled: true },
      { label: 'Finance Charge', fieldKey: 'interest', template: '{interest}', format: 'currency', controlType: 'checkbox-input' },
      { label: 'Waived Fee', fieldKey: 'waivedFee', template: '{waivedFee}', format: 'currency', disabled: true },
      { label: 'Principal', fieldKey: 'principal', template: '{principal}', format: 'currency', disabled: true },
      { label: 'Unpaid Charge', fieldKey: 'unpaidFee', template: '{unpaidFee}', format: 'currency', controlType: 'checkbox-input' }
    ]
  },
  PAY_OFF_IN_N: {
    title: ACTION.PAY_OFF_IN_N.text,
    value: ACTION.PAY_OFF_IN_N.value,
    iconPath: IconPayOffInN,
    privilegeCode: DataType.PrivilegeCode.PAY_OFF_IN_N,
    fieldClass: 'lg4',
    limitValue: true,
    fields: [
      { label: 'Next Payroll Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' },
      { label: 'Payroll Frequency', fieldKey: 'payrollFrequency', template: '{payrollFrequency}', controlType: 'select', disabled: true, items: { payrollFrequency: DataType.PayrollFrequency } },
      { label: '1st Monthly Payday', fieldKey: 'firstDayOfMonth', template: '{firstDayOfMonth}', controlType: 'select', items: { firstDayOfMonth: DataType.DayOfMonth31 } },
      { label: '2nd Monthly Payday', fieldKey: 'secondDayOfMonth', template: '{secondDayOfMonth}', controlType: 'select', items: { secondDayOfMonth: DataType.DayOfMonth31 } },
      { label: '1st Day of Week', fieldKey: 'firstDayOfWeek', template: '{firstDayOfWeek}', controlType: 'select', disabled: true, items: { firstDayOfWeek: DataType.FirstDayOfWeek } },
      { label: 'Finance Charge', fieldKey: 'interest', template: '{interest}', format: 'currency', controlType: 'checkbox-input' },
      { label: 'Waived Fee', fieldKey: 'waivedFee', template: '{waivedFee}', format: 'currency', disabled: true },
      { label: 'Pay Off in N', fieldKey: 'debitCount', template: '{debitCount}' },
      { label: 'Unpaid Charge', fieldKey: 'unpaidFee', template: '{unpaidFee}', format: 'currency', controlType: 'checkbox-input' }
    ]
  },
  PAY_DOWN: {
    title: ACTION.PAY_DOWN.text,
    value: ACTION.PAY_DOWN.value,
    iconPath: IconPayDown,
    privilegeCode: DataType.PrivilegeCode.PAY_DOWN,
    fieldClass: 'lg4',
    limitValue: true,
    fields: [
      { label: 'Disbursement Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ', moreDate: true },
      { label: 'Add Pay Down Amount', fieldKey: 'extraPrincipal', template: '{extraPrincipal}', format: 'currency' },
      { label: 'Max Pay Down Amount', fieldKey: 'maxPayDownAmount', template: '{maxPayDownAmount}', format: 'currency', disabled: true },
      { label: 'Payment Mode', fieldKey: 'transactionMode', template: '{transactionMode}', controlType: 'select', items: { transactionMode: DataType.TransactionMode }, disabled: true }
    ]
  }
}
export { MULTI_PAYMENT_SCHEDULE_ACTION }
